import { jsx } from "panel";
import { InputEl } from "common/components/input";
import { ButtonBarEl } from "common/components/button-bar";
export function template() {
  const { label, value } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".formula-editor-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".formula-editor-main"
  }, /* @__PURE__ */ jsx(InputEl, {
    sel: ".formula-editor-label.formula-editor-text",
    attrs: {
      placeholder: `Formula Name`,
      necessary: `optional`,
      label: `Formula Name`
    },
    props: {
      value: label || ``
    },
    on: {
      input: this.helpers.handleLabelInput,
      keydown: this.helpers.handleLabelKeydown
    }
  }), /* @__PURE__ */ jsx(InputEl, {
    sel: ".formula-editor-text",
    attrs: {
      placeholder: `Use the labels next to the events above as variables to create your formula.

eg. (A+B)/(A-B) * 100`,
      necessary: `required`,
      label: `Formula`,
      type: `textarea`,
      "auto-focus": true
    },
    props: {
      value: value || ``
    },
    on: {
      input: this.helpers.handleValueInput,
      keydown: this.helpers.handleValueKeydown
    },
    hook: {
      insert: this.helpers.handleValueInsert
    }
  })), /* @__PURE__ */ jsx(ButtonBarEl, {
    sel: ".mp-button-bar-primary",
    attrs: {
      disabled: !value
    },
    on: {
      click: this.helpers.handleSaveClick
    }
  }, "Apply Formula"));
}
